import React, { Fragment } from 'react';
import _, { isEmpty } from 'lodash';
import Spin from '../../../commonModules/interface/Spin';
import Photos from '../../../commonModules/interface/input-files';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createAction } from '../../../../../../jsx/actions/devisAction';
import { fetchAll } from '../../../../../../jsx/actions/stockInitAction';
import Dialog, { FormDialog, CalendarDialog } from '../../../commonModules/interface/Dialog';
import { TextField, Grid, Button, IconButton } from '@material-ui/core';
import { InputSelect, InputSelectNative } from '../../../commonModules/interface/form-input-inline';

import InputText from '../../../commonModules/interface/form-input-inline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DatePickerCustom from '../../../commonModules/interface/DatePickerCustom';
import PopUp from '../../../commonModules/interface/PopUp';
import { cyan, teal } from '@material-ui/core/colors';
import { toast } from 'react-toastify';

class DevisActionForm extends React.PureComponent {
    state = {
        status: '',
        comment: '',
        pb: '',
        technician: null,
        questionnaireID:"",
        installatorlist: {},
        action:'',
        price: 0,
        nb_km: "",
        errors:{
            pb:false,
            technician:false,
            comment:false,
            status:false,
            price: false,
            nb_km: false,
            questionnaireID: false,
        },
        loading:false,
        dateVisit:"",
        fullDate:"",
        openCalendar:false,
        files:[],
        // notif:{
        //     title:"", 
        //     type:"", 
        //     message:"",
        //     show:false,
        // },
        
    };
    componentDidMount= async() => {
        if(
            this.props.status === "PLAN_VISIT" || 
            this.props.status === "WAITING_QUOTATION" || 
            this.props.status === "WAITING_VISIT"
        ){
            this.props.fetchSchemas()
        }
    }
    handleChange = (e) => {
        // console.log('====================================');
        // console.log("in handle change", e);
        // console.log('====================================');
        const field = e.target.name
        const value = e.target.value
        this.setState({
            [field]: value
        })
        
    }
    handleChangeInt = (e) => {
        console.log('====================================');
        console.log("in handle change int", e.target);
        console.log('====================================');
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        if(value === "" ) {
            this.setState({
                [field]: value
            })
        } else if(regex.test(value)) {
            this.setState({
                [field]: parseInt(value)
            })
        }
    }
    
    handleChangeDate = (selectedDate) => {
        console.log("IN HANDLE CHANGE date", selectedDate);
        
        this.setState({
            dateVisit: selectedDate,
            openCalendar:false
        })
        this.displayDate(selectedDate)
    }
    displayDate = (datetime) => {
        const WEEKDAYS = ["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"]
        const MONTHS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
        let weekday = WEEKDAYS[datetime.getDay()]
        let date = datetime.getDate()
        let month = MONTHS[datetime.getMonth()]
        let year = datetime.getFullYear()

        const fullDate = (weekday +' '+ date +' '+ month +' '+ year)
        console.log({fullDate});
        this.setState({
            fullDate
        })

    }
    setFiles = (list) => {
        console.log("[INFO] SET_FILES", list);
        this.setState({
            files:list
            
        })
    }
    getRequiredList = () => {
        let list = ["comment", "action"]
        if (this.state.action === "planVisit" || this.state.action === "planVisitUpdate"){
            list.push("dateVisit", "technician", "nb_km", "price", "questionnaireID")
            
        } else if (this.state.action === "changeStatus"){
                list.push("status")
            
        } else if (this.state.action === "endVisit" || this.state.action === "addPdfQuotation"){
            list.push("files")

        }
        return list
    }
    validate = () => {
        let fields = this.getRequiredList()
        console.log('====================================');
        console.log("VALIDATE", {fields});
        console.log('====================================');
        let errors = {}
        let noErrors = true
        fields.map( field => {    
            if( !this.state[field] || this.state[field].length === 0 )
            {
                errors[field] = "Veuillez remplir ce champ"
                noErrors = false
            } else {
                errors[field] = ""
            }
        })
        console.log('====================================');
        console.log({errors});
        console.log('====================================');
        this.setState({
            errors
        })
        return noErrors
    }

    handleSubmit = async () => {
        this.setState({
            loading: true,
        })
        let quotation = {}
        if(this.validate()){

            quotation.boxAssoId = this.props.clientID
            // quotation.client_id = this.props.clientID
            quotation.actionType = this.state.action
            quotation.nextStatus = this.state.status
            quotation.comments = this.state.comment
            if( !isEmpty(this.state.files) ){
                quotation.uploads = this.state.files
            }

            if (this.state.action === "planVisit" || this.state.action === "planVisitUpdate"){
                quotation.nextStatus = "WAITING_VISIT"
                quotation.planVisit = {
                    "dateVisit": this.state.dateVisit,
                    "techID": this.state.technician,
                    "nb_km": this.state.nb_km,
                    "price": this.state.price,
                    "schemaID": this.state.questionnaireID,
                } 
            } else if (this.state.action === "changeStatus"){
                quotation.nextStatus = this.state.status
    
            } else if (this.state.action === "endVisit"){
                quotation.nextStatus = "WAITING_QUOTATION"
    
            } else if (this.state.action === "addPdfQuotation"){
                quotation.nextStatus = "WAITING_VALIDATION"
    
            } else if (this.state.action === "addComment"){
                quotation.nextStatus = "NO_CHANGE"
            } 
            await this.props.createAction(this.props.status, quotation)
                        
            if(this.props.state.error){
                console.log("ERROR", this.props.state.error);
                
                toast.error( "Un Problème est survenu")
            } else{
                console.log("fetched");
                
                this.clearForms()                        
                toast.info("Action enregistré avec succès")
                this.props.handleClose()
            }                
        } else {
            toast.error( "le formulaire contient des erreurs")

        }
        this.setState({
            loading: false,
        })
    } 

    
    clearForms = () => {
        this.setState({
            status: '',
            comment: '',
            pb: '',
            technician: null,
            action:'',
            errors:{
                pb:false,
                technician:false,
                comment:false,
                status:false,
            },
            loading:false,
            dateVisit:"",
            fullDate:"",
            openCalendar:false,
            files:[],
        })
    }
    
    render() {
        console.log("STATE STATE", this.state);
        const { installatorlist, loading} = this.state;
        const { INSTALLERS } = this.props;
        // 'PLAN_VISIT', 'WAITING_VISIT', 'WAITING_QUOTATION',  'WAITING_ANSWER', 'REFUSED', 'VALIDATE', 'WAITING_VALIDATION', 'INSTALLED'
        const changeStatusList = [
            'PLAN_VISIT',
            'WAITING_VALIDATION',
            'WAITING_ANSWER',
            'VALIDATE',
            'REFUSED',
        ]
        const planVisitList = [
            'PLAN_VISIT',
            'WAITING_QUOTATION',
            'REFUSED',
        ]
        let actionOptions = []
        let newStatusOpt = []
                                    
        
        if ( planVisitList.includes(this.props.status)) {
            actionOptions.push(
                <option value="planVisit">Planifier une Visite</option>
            )
        }
        if ( this.props.status === "WAITING_QUOTATION") {
            actionOptions.push(<option value="addPdfQuotation">Joindre un Devis</option>)
        }
        if ( changeStatusList.includes(this.props.status) ) {
            actionOptions.push(<option value="changeStatus">Changer le Statut</option>)
        }
        if ( this.props.status === 'WAITING_VISIT' ) {
            actionOptions.push(
                <option value="planVisitUpdate">Replanifier une Visite</option>,
                <option value="endVisit">Rapport de visite</option>
            )
        }
        actionOptions.push(<option value="addComment">Ajouter un commentaire</option>)


        if (this.props.status === "PLAN_VISIT"){ 
            newStatusOpt.push(<option value="WAITING_QUOTATION">En attente de Devis</option>)
        }
        if (this.props.status === 'WAITING_VALIDATION'){ 
            newStatusOpt.push(<option value="WAITING_ANSWER">Devis Valide</option>)
            newStatusOpt.push(<option value="WAITING_QUOTATION">Devis non valide</option>)
        }
        if (this.props.status === 'VALIDATE'){ 
            newStatusOpt.push(<option value="INSTALLED">Système installé</option>)
        }
        if (this.props.status === 'REFUSED'){ 
            newStatusOpt.push(<option value="WAITING_ANSWER">En attente de réponse</option>)
        }
        
        return (
            <PopUp
                title={this.props.title}
                close={this.props.close}
                submitAction={this.state.action && this.handleSubmit} 
            >
                <Grid > 
                    { loading && <Spin />}      
                    {this.state.questionnaireID && this.state.showQuest &&
                        <FormDialog ID={this.state.questionnaireID} close={()=>this.setState({ showQuest: false }) }/>
                    }
                    
                    {/* {this.state.openCalendar &&
                        <CalendarDialog 
                            title="Choisir une date de visite"
                            close={()=>this.setState({openCalendar:false})} 
                            handleChangeDate={this.handleChangeDate}  
                            selected={this.state.dateVisit}
                        />
                    } */}
                    <Grid container spacing={2} >
                        <Grid item xs={12}>
                            <InputSelectNative
                                label="Choisissez une Action"
                                required
                                onChange={(e) => this.setState({ action: e.target.value, errors:{} })}
                                options={actionOptions}
                            />
                        </Grid>
                                    
                        
                        { (this.state.action === 'changeStatus' && this.props.status !== 'WAITING_ANSWER')  && 
                            <Grid item xs={12} sm={6}>
                                <InputSelectNative
                                    label="Nouveau Statut"
                                    required
                                    name="status"
                                    onChange={this.handleChange}
                                    options={newStatusOpt}
                                    error={this.state.errors.status}
                                />
                            </Grid>
                        } 
                        { (this.state.action === 'changeStatus' && this.props.status === 'WAITING_ANSWER')  &&
                        <Grid item xs={12} sm={6}>
                            <InputSelectNative
                                label="Réponse du Client"
                                required
                                name="status"
                                onChange={this.handleChange}
                                options={[
                                    <option></option>,
                                    <option value="VALIDATE">Le client accepte le devis</option>,
                                    <option value="REFUSED">Le client refuse le devis</option>,
                                    <option value="WAITING_QUOTATION">Le client demande un nouveau devis</option>,
                                ]}
                                error={this.state.errors.status}
                            />
                        </Grid>
                        }
                        
                        { (this.state.action === 'planVisit' || this.state.action === 'planVisitUpdate') &&
                        <Fragment>
                            <Grid item sm={6} xs={12}>
                                <DatePickerCustom
                                    required
                                    label="Choisir une date de visite"
                                    handleChange={(date)=> this.setState({ dateVisit: date})}
                                    value={this.state.dateVisit}
                                    id="dateVisit"
                                    minDate={new Date()}
                                    error={this.state.errors.dateVisit}
                                />
                            </Grid>
                            
    
                            <Grid item sm={6} xs={12}>
                                <InputSelectNative
                                    label="Choisir un technicien"
                                    required
                                    name="technician"
                                    onChange={this.handleChange}
                                    options={ !isEmpty(INSTALLERS) && Object.values(INSTALLERS).map(item => (
                                        <option key={item.id} value={item.id}>{item.name}</option>
                                    ))
                                    }
                                    error={this.state.errors.technician}
                                />
                            </Grid>
                            
                            <Grid item sm={6} xs={12}>
                                <InputText
                                    type="number" 
                                    value={this.state.price} 
                                    name="price" 
                                    label="Prix de l'Intervention"
                                    error={this.state.errors.price}
                                    onChange={this.handleChangeInt}
                                    required
                                />
                            </Grid>
    
                            <Grid item sm={6} xs={12} >
                                <InputText
                                    type="number" 
                                    value={this.state.nb_km} 
                                    name="nb_km" 
                                    label="Nombre de Km Prévu"
                                    error={this.state.errors.nb_km}
                                    onChange={this.handleChangeInt}
                                    required
                                />
                            </Grid>
    
                            <Grid item sm={6} xs={12}>
                                <InputSelectNative
                                    label="Questionnaire technicien"
                                    required
                                    name="questionnaireID"
                                    onChange={this.handleChange}
                                    options={this.props.schemasList.map(schema =>
                                        <option key={schema.id} value={schema.id}>
                                            {schema.name}
                                        </option>
                                    )}
                                    error={this.state.errors.questionnaireID}
                                />
                                <br/>
                                <Button 
                                    variant="contained"
                                    // color="secondary"
                                    style={{ backgroundColor: teal[200]}}
                                    onClick={this.props.openNewSchema}
                                >
                                    Créer un Formulaire
                                </Button>
                                {this.state.questionnaireID && 
                                    <IconButton 
                                        variant="contained"
                                        color="primary"
                                        onClick={()=>this.setState({showQuest: true})}
                                    >
                                        <VisibilityIcon />
                                    </IconButton>
                                }
                            </Grid>
    
                            <Grid item sm={6} xs={12}>
                                <InputText
                                    value={this.state.comment} 
                                    name="comment" 
                                    label="Informations complémentaires"
                                    error={this.state.errors.comment}
                                    onChange={this.handleChange}
                                    required
                                    rows={4}
                                />
                                {/* <label className="fg-label control-label">Informations complémentaires *</label>
                                <div className={this.state.commentF ? 'fg-line fg-toggled' : 'fg-line'}>
                                    <textarea
                                        onFocus={() => this.setState({ commentF: true })}
                                        onBlur={() => this.setState({ commentF: false })}
                                        name="comment"
                                        onChange={this.handleChange}
                                        className="form-control"
                                        rows="5"
                                    >
                                    </textarea>
                                </div>
                                {this.state.errors.comment && <small className="help-block">Ce champ est requis.</small> } */}
                            </Grid>
                        </Fragment>
                        }
    
                        {(this.state.action === 'addComment' || 
                        this.state.action === 'changeStatus' || 
                        this.state.action === 'endVisit' || 
                        this.state.action === 'addPdfQuotation') &&
                            <Grid item sm={6} xs={12}>
                                <InputText
                                    value={this.state.comment} 
                                    name="comment" 
                                    label="Commentaire"
                                    error={this.state.errors.comment}
                                    onChange={this.handleChange}
                                    required
                                    rows={4}
                                />
                            </Grid>
                        }
                        
                        {(this.state.action === 'addComment' && this.props.status === "VALIDATE") && 
    
                        <Grid item sm={6} xs={12}>
                            <label className="fg-label control-label">Ajouter un Fichier </label>
                            <Photos photoList={this.setFiles} photos={this.state.files === null ? [] : this.state.files } file />
                            {this.state.errors.files && <small className="help-block">Ce champ est requis.</small> }
                        </Grid>
                        }
                        {( (
                            this.state.action === 'endVisit' || 
                            this.state.action === 'changeStatus' || 
                            this.state.action === 'addPdfQuotation'
                            ) && 
                            this.props.status !== 'WAITING_VALIDATION'
                        ) && 
    
                        <Grid item sm={6} xs={12}>
                            <label className="fg-label control-label">Ajouter un Fichier {
                                (this.state.action === 'endVisit' || 
                                this.state.action === 'addPdfQuotation' 
                                ) && "*"} 
                            </label>
                            <Photos photoList={this.setFiles} photos={this.state.files === null ? [] : this.state.files } file />
                            {this.state.errors.files && <small className="help-block">Ce champ est requis.</small> }
                        </Grid>
                        }
                    </Grid>
                </Grid>                               
            </PopUp>
        );
    }
}
function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        CLIENTS: state.clients,
        INSTALLERS: state.installers,
        state: state.inventory.requestState.devis,
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        createAction,
        fetchAll,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DevisActionForm);